/**
 * Appending Investment Programme text to programmeName if doesn't exist
 * @param text
 * @returns text + Investment Programme
 */
export const addInvestmentProgrammeNameToText = (text: string) => {
	if (!text) {
		return;
	}

	const words = text.split(' ');

	const lastTwoWords = `${words[words.length - 2]} ${words[words.length - 1]}`.toLowerCase();

	if (lastTwoWords === 'investment programme') {
		return text;
	}
	const textToAppend = ' Investment Programme';
	return `${text} ${textToAppend}`;
};

export const getUserNameInitials = (name?: string): string => {
	// split by one or more spaces
	const names = name?.trim().split(/\s+/).filter(Boolean);
	if (!names?.length) {
		return '';
	}
	const firstNameLetter = names[0].charAt(0);
	const lastNameLetter = names.length > 1 ? names[names.length - 1]?.charAt(0) : '';

	return `${firstNameLetter}${lastNameLetter}`.toUpperCase();
};
